import { createMuiTheme } from "@material-ui/core/styles";

const darkTheme = createMuiTheme({
  palette: {
    type: "dark",
    primary: {
      main: "#000000"
    },
    secondary: {
      main: "#404040"
    }
  },
  typography: {
    h1: {
      fontSize: "2rem",
      fontWeight: 500
    },
    h2: {
      fontSize: "1.5rem",
      fontWeight: 400
    },
  }
});

export default darkTheme;